/**
 * @file ScrollToTop.js
 * @description A React component that automatically scrolls the window to the top
 * whenever the route changes. This ensures users always start at the top of the page
 * when navigating between different routes in the application.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component
 * @returns {null} This component doesn't render anything
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
